import { jsx as _ } from "react/jsx-runtime";
import { ai as D, p as J, J as L, d as O, r as R, aj as T } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as V, useMemo as k, Fragment as q, memo as z } from "react";
import { isAutoColor as E } from "../../theme/color.js";
import { stupidInvertClasses as G } from "../../utils/index.js";
import { I as K } from "../../iconLoader.gen-DwgfiXjs.js";
import { getSpacingClasses as Q } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index4.css';const U = "_xs_gv6b3_1", X = "_sm_gv6b3_5", Y = "_md_gv6b3_9", Z = "_lg_gv6b3_13", oo = "_xl_gv6b3_17", so = "_baseIcon_gv6b3_21", eo = "_moon_gv6b3_58", to = "_red_gv6b3_62", ao = "_sienna_gv6b3_66", no = "_gold_gv6b3_70", co = "_cactus_gv6b3_74", ro = "_green_gv6b3_78", _o = "_teal_gv6b3_82", io = "_blue_gv6b3_86", lo = "_purple_gv6b3_90", mo = "_magenta_gv6b3_94", a = {
  xs: U,
  sm: X,
  md: Y,
  lg: Z,
  xl: oo,
  baseIcon: so,
  moon: eo,
  red: to,
  sienna: ao,
  gold: no,
  cactus: co,
  green: ro,
  teal: _o,
  blue: io,
  purple: lo,
  magenta: mo
}, bo = V(
  ({
    id: i,
    m: d,
    mt: l,
    mr: m,
    mb: b,
    ml: g,
    p: v,
    pt: p,
    pr: f,
    pb: u,
    pl: $,
    icon: n,
    description: c,
    color: o,
    __inverted: x,
    size: I = "md",
    className: h,
    slot: C,
    ...s
  }, P) => {
    const t = K[n] ?? "", y = k(() => ({ __html: t }), [t]), B = D(i), e = !!c, { focusProps: F, isFocused: M, isFocusVisible: j } = J(s), { hoverProps: A, isHovered: H } = L(s);
    if (!t)
      return null;
    const r = E(o), N = O(
      a.baseIcon,
      a[I],
      r ? a[o] : void 0,
      Q({ m: d, mb: b, ml: g, mr: m, mt: l, p: v, pb: u, pl: $, pr: f, pt: p }),
      x ? G() : void 0,
      h
    ), S = e ? { "aria-label": c, role: "img" } : { "aria-hidden": !0 }, W = e ? {
      "data-focus-visible": j || void 0,
      "data-focused": M || void 0,
      "data-hovered": H || void 0
    } : {}, w = e ? R(s, A, F) : s;
    return /* @__PURE__ */ _(e ? T : q, { children: /* @__PURE__ */ _(
      "span",
      {
        ...w,
        ...S,
        ...W,
        style: o && !r ? { "--icon-color": `var(--${o})` } : void 0,
        slot: C,
        id: B,
        ref: P,
        "data-icon": n,
        className: N,
        dangerouslySetInnerHTML: y
      }
    ) });
  }
), ho = z(bo);
export {
  ho as BaseIcon
};
